import {useIsRouting} from "@solidjs/router";
import {createEffect, ErrorBoundary, JSXElement} from "solid-js";
import Error from "~/components/Error";
import Footer from "~/components/layout/Footer";
import Header from "~/components/layout/Header";
import css from "~/css/layout/layout.module.css";

export default function Layout(props: { children: JSXElement }) {

    let app!: HTMLDivElement

    const isRouting = useIsRouting();

    createEffect(() => {
        if (isRouting()) {
            app.scrollTop = 0
        }
    })

    return (
        <div ref={app} class={css.app}>
            <Header/>
            <div class={css.content}>
                <ErrorBoundary fallback={Error}>
                    {props.children}
                </ErrorBoundary>
            </div>
            <Footer/>
        </div>
    )
}